export const ROUTE_CONTACT = '/contact';
export const ROUTE_ACCOUNT = '/account';
export const ROUTE_LOGIN = '/login';
export const ROUTE_FAQ = '/faq';
export const ROUTE_BILLING = '/billing';
export const ROUTE_FREE_MINUTES = '/free_minutes';
export const ROUTE_PACKAGES = '/packages';
export const ROUTE_SEND_PASSWORD = '/send_lost_password_email';
export const ROUTE_RESET_PASSWORD = '/reset_lost_password';
export const ROUTE_REGISTER = '/register';
export const ROUTE_TC = '/terms';
export const ROUTE_CREATE_BOOKING = '/create_booking';
export const ROUTE_MY_BOOKINGS = '/my_bookings';
export const ROUTE_INVOICES_REPLAY = '/invoice_require_authentication';
export const ROUTE_REDIRECT_PAYMENT = '/stripe_redirection';
export const ROUTE_REDIRECT_PAYMENT_BOOKING = '/stripe_redirection_booking';
export const ROUTE_STATION_INFORMATION = '/station_information';
export const ROUTE_FUEL_CARD_DETAILS = '/fuel_card_details';
export const ROUTE_PAYMENT_RESULT = '/payment-result';
export const ROUTE_MOBILITY_PLAN = '/mobility-plan';
export const ROUTE_OAUTH2_CALLBACK = '/oauth2/callback';
export const ROUTE_SSO_BRIDGE = '/sso/bridge';
